/*
 * Module for the status pills used by the topic tasks list
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicTasks/topicTasksListToggle/topicTasksListToggleView",
  "modules/tasks/tasksModel",
], function (Marionette, Messenger, TopicTasksListToggleView, TaskModel) {
  "use strict";

  var TopicTasksListToggleController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicTasksListToggle";
      this.region = options.region;
    },
    show: function () {
      this.view = new TopicTasksListToggleView.topicTasksListToggleView();

      this.view.on(
        "show:not:started",
        function () {
          Messenger.vent.trigger("show:tasks:list", TaskModel.STATUS.NOT_STARTED);
        },
        this,
      );

      this.view.on(
        "show:in:progress",
        function () {
          Messenger.vent.trigger("show:tasks:list", TaskModel.STATUS.IN_PROGRESS);
        },
        this,
      );

      this.view.on(
        "show:rejected",
        function () {
          Messenger.vent.trigger("show:tasks:list", TaskModel.STATUS.FAILED);
        },
        this,
      );

      this.view.on(
        "show:all",
        function () {
          Messenger.vent.trigger("show:tasks:list", TaskModel.STATUS.ALL);
        },
        this,
      );

      this.showRegion(this.view);
    },
    selectTab: function (statusId) {
      if (statusId === 0) {
        this.view.selectNotStarted();
      }
    },
  });

  return TopicTasksListToggleController;
});
